module.exports = __webpack_public_path__ + "static/vegetable-basket-99591745fbedda75f764c2e245fa39d7.jpg";